module.exports = "<form style=\"margin: 0;\" class=\"flexbox-container\">\n\n  <app-argomento-search class=\"width-65\" required [(ngModel)]=\"selectedArgomento\" name=\"selectedArgomento\" (ngModelChange)=\"onArgomentoChange($event)\"></app-argomento-search>\n\n  <button *ngIf=\"eraseable\" mat-icon-button (click)=\"eraseMe()\">\n    <mat-icon>clear</mat-icon>\n  </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/argomento-selector/argomento-selector.component.html
// module id = ./src/app/components/book/argomento-selector/argomento-selector.component.html
// module chunks = main